<form class="access-type-list">
  <mat-form-field>
    <mat-icon matSuffix>arrow_drop_down</mat-icon>
    <input type="text" [placeholder]="placeHolder" aria-label="Number" matInput [formControl]="myControl"
      [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
      <mat-option *ngFor="let accessType of filteredAccessTypes | async" [value]="accessType">
        {{accessType?.name}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</form>

<!-- <form class="accessType-list">
  <mat-form-field>
    <mat-select [formControl]="myControl">
      <mat-option *ngFor="let accessType of companies" [value]="accessType">
         {{accessType?.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form> -->